import { Middleware, isRejectedWithValue } from "@reduxjs/toolkit";
import { showError } from "../../services/toast.service";

/**
 * Middleware that listens for rejected async thunks and displays
 * exactly ONE error toast notification, preventing repeated toasts or unhandled errors.
 */
export const errorMiddleware: Middleware = () => (next) => (action: any) => {
  if (isRejectedWithValue(action)) {
    const errorMessage =
      typeof action.payload === "string"
        ? action.payload
        : action.payload?.message || action.error?.message;

    if (errorMessage && !errorMessage.includes("Aborted due to condition")) {
      showError(errorMessage, { id: `${action.type}:${errorMessage}` });
    }
  }

  return next(action);
};
